import { getAllGroupsService, getGroupService } from '../services/groupService';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getGroups = createAsyncThunk('groups/getGroups', async () => {
  const response = await getAllGroupsService();
  return response.data;
});

export const getGroup = createAsyncThunk('groups/getGroup', async (id) => {
  const response = await getGroupService(id);
  return response.data;
});

// slice
const groupsSlice = createSlice({
  name: 'groups',
  initialState: {},
  reducers: {
    removeGroup(state, action) {
      const idToRemove = action.payload;
      if (state[idToRemove]) {
        const { [idToRemove]: value, ...withoutGroup } = state;
        return withoutGroup;
      }
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroups.pending, (state) => {
        console.log('Fetching groups...');
        return state;
      })
      .addCase(getGroups.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(getGroups.rejected, (state, action) => {
        console.error('Failed to fetch groups:', action.error);
      })
      .addCase(getGroup.pending, (state) => {
        console.log('Fetching group...');
        return state;
      })
      .addCase(getGroup.fulfilled, (state, action) => {
        const groupId = action?.meta?.arg?.[0];
        return { ...state, [groupId]: action.payload?.[groupId] };
      })
      .addCase(getGroup.rejected, (state, action) => {
        console.error('Failed to fetch group:', action.error);
      });
  },
});

export default groupsSlice.reducer;
export const { removeGroup } = groupsSlice.actions;
export const groupsSelectors = {
  selectGroups: (state) => state.groups,
  selectGroupById: (state, id) => state.groups[id],
};
